import { defineStore } from 'pinia'

export const useWidgetStore = defineStore('widget-store', {
  state: () => ({
    error: {},
    widgetRegistrations: {
      widgets: {}
    },
    sliderStates: {},
    deregisteredWidgets: {}
  }),
  getters: {
    getDeregisteredWidgets: (state) => {
      return state.deregisteredWidgets
    },
    getWidgetRegistrations: (state) => {
      return state.widgetRegistrations
    },
    getWidgetSliderStates: (state) => {
      return state.sliderStates
    }
  },
  actions: {
    clear() {
      this.widgetRegistrations = {
        widgets: {}
      }
      this.sliderStates = {}
      this.deregisteredWidgets = {}
    },
    resetWidgetDeregistrationsAction() {
      this.deregisteredWidgets = {}
    },
    deregisterWidgetAction({ id, info }) {
      try {
        this.deregisteredWidgets = {
          ...this.deregisteredWidgets,
          [id]: {
            info,
            oldWidget: this.widgetRegistrations.widgets[id]
          }
        }
        if (this.widgetRegistrations.widgets?.[id]) {
          delete this.widgetRegistrations.widgets[id]
        }
      } catch (error) {
        this.error = error
        throw error
      }
    },
    registerWidgetAction({ groupName, id, information, data }) {
      try {
        this.widgetRegistrations = {
          groupName,
          widgets: {
            ...this.widgetRegistrations.widgets,
            [id]: {
              ...information,
              data
            }
          }
        }
      } catch (error) {
        this.error = error
        throw error
      }
    },
    // give all deregistered widgets a second chance cause maybe time period has changed
    reRegisterWidgetsAction() {
      try {
        const oldWidgets = Object.keys(this.deregisteredWidgets).reduce(
          (acc, widgetId) => {
            return {
              ...acc,
              [widgetId]: this.deregisteredWidgets[widgetId].oldWidget
            }
          },
          {}
        )
        this.widgetRegistrations = {
          groupName: this.widgetRegistrations.groupName,
          widgets: {
            ...this.widgetRegistrations.widgets,
            ...oldWidgets
          }
        }
        this.deregisteredWidgets = {}
      } catch (error) {
        this.error = error
        throw error
      }
    },
    // Add more information that this widget needs such as results per person
    updateWidgetRegistrationAction({ groupName, id, requests, mode }) {
      try {
        let newRequests = {
          ...(this.widgetRegistrations.widgets[id]?.requests || {})
        }
        if (mode === 'add') {
          newRequests = {
            ...newRequests,
            ...requests
          }
        } else if (mode === 'remove') {
          for (const key in requests) {
            delete newRequests[key]
          }
        }

        this.widgetRegistrations = {
          ...this.widgetRegistrations,
          groupName,
          widgets: {
            ...this.widgetRegistrations.widgets,
            [id]: {
              requests: newRequests
            }
          }
        }

        // this.widgetRegistrations[groupName][id].requests = newRequests
      } catch (error) {
        this.error = error
        throw error
      }
    },
    clearWidgetRegistrations() {
      this.widgetRegistrations = {}
    },
    resetWidgetSliderStates() {
      this.sliderStates = {}
    },
    updateWidgetSliderAction({ id, index, info }) {
      try {
        this.sliderStates[id] = { index, info }
      } catch (error) {
        this.error = error
        throw error
      }
    }
  }
})
